/* eslint-disable no-unused-vars */
import {Box, Grid} from '@mui/material'
import styled from 'styled-components'
import VideoGrid from './VideoGrid'

export default function Home(props){
    return (
        <Box 
            sx={{
                // width: "100%",
                // height: "100%",
                // background: "#181818",
                // color: "#fff",
                // overflowY: "scroll"
            }}
        >
            <VideoGrid/>
        </Box>
    )
}